import React from 'react'

import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import PaymentAttachmentsCard from '../../../components/details/attachments/PaymentAttachmentsCard'

import { NO_EFFECTIVE_VISIT_HEADER_CONFIG } from '../shared/noEffectiveVisitConstants'
import NoEffectiveVisitSummarySection from '../shared/NoEffectiveVisitSummarySection'

export default function NoEffectiveVisitDetailsDesktop({
  activity,
  summaryFields,
  fieldsToRender,
  paymentAttachments
}) {
  return (
    <div className="container-fluid px-0">
      <div className="show-product-header">
        <h3 className="margin-text-subtitle">Detalles de visita:</h3>
      </div>
      <hr />

      <ClientHeader data={activity} config={NO_EFFECTIVE_VISIT_HEADER_CONFIG} />
      <hr />

      <NoEffectiveVisitSummarySection
        summaryFields={summaryFields}
        extraFields={fieldsToRender}
      />

      <PaymentAttachmentsCard
        images={paymentAttachments.images}
        files={paymentAttachments.files}
        title="ADJUNTO(S)"
        emptyDescription="Cuando esta visita tenga imágenes o archivos asociados, aparecerán aquí para su revisión."
      />
    </div>
  )
}
